module.exports = {"530427001":"桂山街道","530427002":"古城街道","530427100":"扬武镇","530427101":"漠沙镇","530427102":"戛洒镇","530427103":"水塘镇","530427200":"平甸乡","530427201":"新化乡","530427202":"建兴乡","530427203":"老厂乡","530427204":"者竜乡","530427205":"平掌乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530427.json
// module id = 2706
// module chunks = 0